// Story 10.1 — Bootstrap. `@axe-core/react` solo se carga en dev.
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './globals.css';

async function bootstrap(): Promise<void> {
  // Suprimir el warning benigno `ResizeObserver loop completed with
  // undelivered notifications` que disparan Monaco (`automaticLayout`),
  // ReactFlow, y `react-resizable-panels` cuando el layout cambia entre
  // frames. El browser lo maneja solo en el siguiente frame, pero la
  // extension SES (MetaMask) lo wrappea como `SES_UNCAUGHT_EXCEPTION:
  // null` porque viene sin un Error real (`error: null`). Silenciarlo
  // antes de que llegue al global handler limpia el ruido.
  window.addEventListener(
    'error',
    (e) => {
      if (e.message?.startsWith('ResizeObserver loop')) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true,
  );

  if (import.meta.env.DEV) {
    // Lazy import: NUNCA en bundle de producción.
    const { default: axe } = await import('@axe-core/react');
    axe(React, ReactDOM, 1000);
  }

  // biome-ignore lint/style/noNonNullAssertion: #root is in index.html, guaranteed.
  const container = document.getElementById('root')!;
  ReactDOM.createRoot(container).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

void bootstrap();
